import { ReactElement } from 'react';
import { useUserInfo } from '../user-info';

type EsNorcalProviderGuardProps = {
  children: ReactElement;
};

export const EsNorcalProviderGuard = ({
  children,
}: EsNorcalProviderGuardProps) => {
  return (
    <ProviderGuard providerName='Easter Seals Northern California'>
      {children}
    </ProviderGuard>
  );
};

type ProviderGuardProps = {
  children: ReactElement;
  providerName: string;
};

const ProviderGuard = (props: ProviderGuardProps) => {
  const { children, providerName } = props;
  const userInfo = useUserInfo();
  if ([...userInfo.currentProviders.values()].includes(providerName)) {
    return children;
  }
  return null;
};
